// Reports section. Sub-routes:
//   /reports/monthly    Monthly Report — cross-cutting summary of the
//                       entire Command Center, designed to be the once-
//                       a-month read where decisions get made. Pulls
//                       from finance, marketing, pipeline, clients, and
//                       insurance into a single curated view.

import SectionLayout from '../../components/common/SectionLayout';

const ITEMS = [
  { to: '/reports/monthly', label: 'Monthly Report', end: true },
];

export default function ReportsSection() {
  return <SectionLayout title="Reports" items={ITEMS} />;
}
